import { FC, useState } from 'react';
import { Button, Container } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import logo from '../assets/img/logo-text.png';

const IntroPage: FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation(['intro']);
  const [currentPage, setCurrentPage] = useState('first');

  const handleClick = () => {
    if (currentPage === 'first') {
      setCurrentPage('second');
    } else {
      setCurrentPage('');
      setTimeout(() => navigate('/login'), 500);
    }
  };

  return (
    <Container fluid className="position-relative overflow-hidden vh-100 p-0">
      {/* First Page */}
      <div
        className={`page-slider ${
          currentPage === 'first' ? 'slide-active' : 'slide-out-left'
        }`}
      >
        <div className="d-flex flex-column justify-content-center align-items-center h-100 gap-4 p-5">
          <img height={200} src={logo} alt="vihupole" />
          <p className="text-center text-uppercase">{t('title')}</p>
        </div>
      </div>
      {/* Second Page */}
      <div
        className={`page-slider slide-${
          currentPage === 'second'
            ? 'active'
            : currentPage === 'first'
            ? 'in-right'
            : 'out-left'
        }`}
      >
        <div className="d-flex flex-column justify-content-center align-items-center h-100 gap-2 p-5">
          {Array.from({ length: 4 }, (_, index) => (
            <p key={index} className="text-center">
              {t(`message.p${index + 1}`)}
            </p>
          ))}
          <img height={60} src={logo} alt="vihupole" />
        </div>
      </div>
      {/* Button fixed at the bottom right */}
      <Button
        variant="outline-dark"
        onClick={handleClick}
        className="position-fixed bottom-0 end-0 translate-middle-y text-uppercase m-4"
      >
        {t('next')}
      </Button>
    </Container>
  );
};

export default IntroPage;
